import Cookies from 'universal-cookie';
import { get } from 'lodash';
import { apolloSkywardImg, axaImg, virtuImg } from '../components/Images';

export const getJSON = (key, def = {}) => {
    const value = localStorage.getItem(key);
    if (value && value !== "undefined") {
        return JSON.parse(localStorage.getItem(key));
    }
    return def;
}

export const setJSON = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
}

export const getSort = (key, def) => {
    let data = getJSON(key);
    if (data.field && data.order) {
        return data;
    }
    return def;
}

export const setSort = (key, data) => {
    if (data.field && data.order) {
        setJSON(key, data);
    }
}


export const getCookie = (cookiename = "usertoken", parseJson = false, alt = "") => {
    // Get name followed by anything except a semicolon
    var cookiestring = RegExp(cookiename + "=[^;]+").exec(document.cookie);
    // Return everything after the equal sign, or an empty string if the cookie name not found
    cookiestring = decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
    if (parseJson && cookiestring) {
        cookiestring = JSON.parse(cookiestring);
    }
    return cookiestring || alt;
}

export const setCookie = (value, cookiename = "usertoken", remember = true, options = { path: "/", secure: true, sameSite: 'Strict' }) => {
    const cookies = new Cookies();
    if (remember) {
        options = { ...options, maxAge: 2592000 }
    }
    cookies.set(cookiename, value, options);
}

export const deleteCookie = (cookiename = "usertoken", options = { path: "/", secure: true, sameSite: 'Strict' }) => {
    const cookies = new Cookies();
    cookies.remove(cookiename, options);
}

export const getSites = () => {
    return {
        "apollo": {
            image: apolloSkywardImg,
            iconColor: '#00A8B0',
            name: 'Apollo'
        },
        "virtu": {
            image: virtuImg,
            iconColor: '',
        },
        "axa": {
            image: axaImg,
            iconColor: '',
        }
    }
}

export const getSite = () => {
    return process.env.REACT_APP_SITE;
}

export const getSiteAttr = (attr) => {
    return get(getSites(), `${getSite()}.${attr}`);
}

export const getUserAttr = (userData, attr) => {
    return get(userData, attr);
}